module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"offMic":"Микрофон выключен","offCamera":"Камера выключена"}}')
  delete Component.options._Ctor
}
